import styled, { css } from 'styled-components';

import {
  calculateFontSize,
  defaultThemeProp,
  StyledFlex,
  StyledFilterRegion,
  StyledGrid,
  StyledRegion
} from '@pega/cosmos-react-core';
import { StyledTableWrapper } from '@pega/cosmos-react-core/lib/components/Table/Table';

export const StyledStoryPage = styled.div<{
  secondary?: boolean;
}>(({ theme, secondary }) => {
  const fontSize = calculateFontSize(theme.base['font-size'], theme.base['font-scale']);

  return css`
    ${StyledRegion} {
      border: 0.0625rem dashed ${theme.base.palette['border-line']};
      background-color: ${theme.base.palette[
        secondary ? 'secondary-background' : 'primary-background'
      ]};
    }

    ${StyledFlex}${StyledRegion}:not(${StyledFilterRegion}) {
      display: flex;
      justify-content: center;
      align-items: center;
      align-self: stretch;
      text-transform: uppercase;
      font-size: ${fontSize.xxl};
    }

    ${StyledGrid}${StyledRegion}:not(${StyledFilterRegion}) {
      display: grid;
      justify-items: center;
      align-content: center;
      align-self: stretch;
      text-transform: uppercase;
      font-size: ${fontSize.xxl};
    }
  `;
});

StyledStoryPage.defaultProps = defaultThemeProp;

const minTableHeight = '400px'; // compute based on number of rows.
const tableComponentInternalHeightOffset = '54px'; // compute based on component internal padding & heading height.

export const StyledDemoTableWrapper = styled.div`
  ${StyledTableWrapper} {
    max-height: calc(var(--content-height-in-view) - ${tableComponentInternalHeightOffset});
    min-height: ${minTableHeight};
  }
`;

export const StyledGridViewerWrapper = styled.div`
  block-size: var(--content-height-in-view, 100vh);
  overflow: auto;
`;

export const StyledGridChildWrapper = styled.div`
  inline-size: 100%;
  block-size: 100%;
  overflow: auto;
`;
